import { render, staticRenderFns } from "./_MasterDuplicates.vue?vue&type=template&id=c1fab442&slot=Content&"
import script from "./_MasterDuplicates.vue?vue&type=script&lang=js&"
export * from "./_MasterDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports